// extracted by mini-css-extract-plugin
export default {"editorWrapper":"TiptapEditor_editorWrapper__lnVJT","is-editor-empty":"TiptapEditor_is-editor-empty__qeOZa"};